import React, { useState } from "react";
import PropTypes from "prop-types";

import useWindowSize from "hooks/useWindowSize";
import { K_MOBILE_SIZE } from "constants.js";

const AccordionItem = (props) => {
  const {
    isActive,
    index,
    title,
    subtitle,
    content,
    primaryColor,
    secondaryColor,
    fillColor,
  } = props;

  const [isExpanded, setIsExpanded] = useState(isActive);
  const [isHovered, setIsHovered] = useState(false);
  const { width } = useWindowSize();

  const styles = {
    ...pcStyles,
    ...(width < K_MOBILE_SIZE ? mobileStyles : {}),
  };

  const getFormattedIndex = (index) => ("0" + index).slice(-2);
  const colorStyle = {
    backgroundColor: fillColor,
    color: isExpanded || isHovered ? primaryColor : secondaryColor,
  };

  const contentStyle = {
    maxHeight: isExpanded ? "100%" : "0",
    opacity: isExpanded ? 1 : 0,
    transform: isExpanded ? "translateY(10px)" : "translateY(0)",
  };

  return (
    <div
      onClick={() => setIsExpanded(!isExpanded)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        ...styles.accordionItemContainer,
        ...colorStyle,
        ...styles.container,
      }}
    >
      <div style={styles.container}>
        <div style={styles.number}>{getFormattedIndex(index)}</div>
        <div style={styles.headerContainer}>
          <div style={styles.header}>
            <div>
              <div style={styles.title}>{title}</div>
              <div style={styles.subtitle}>{subtitle}</div>
            </div>
          </div>
          <div style={{ ...styles.contentContainer, ...contentStyle }}>
            {content}
          </div>
        </div>
      </div>
      <div style={styles.arrowContainer}>
        <i
          style={{ ...styles.arrow, ...colorStyle }}
          className={
            isExpanded ? "fa fa-angle-down fa-rotate-180" : "fa fa-angle-down"
          }
        />
      </div>
    </div>
  );
};

const pcStyles = {
  accordionItemContainer: {
    padding: "0.5rem",
    textAlign: "justify",
    transition: "color 0.5s, opacity 0.8s, transform 0.75s, max-height 0.5s",
    justifyContent: "space-around",
    margin: 0,
  },
  container: {
    width: "100%",
    maxWidth: "1200px",
    display: "flex",
    cursor: "pointer",
  },
  number: {
    fontSize: "4rem",
    paddingRight: "1rem",
  },
  title: {
    textAlign: "left",
    fontSize: "1.5rem",
  },
  subtitle: {
    fontSize: "0.75rem",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingTop: "1rem",
  },
  headerContainer: {
    flexGrow: 1,
  },
  arrow: {
    transition: "all 0.6s cubic-bezier(0.080, 1.090, 0.320, 1.275)",
    fontSize: "1.5rem",
  },
  arrowContainer: {
    padding: "0.5rem",
    paddingLeft: "2rem",
  },
  contentContainer: {
    paddingTop: "0rem",
    paddingBottom: "1rem",
    transition: "opacity 0.8s, transform 0.75s, max-height 0.5s",
    overflow: "hidden",
  },
};

const mobileStyles = {
  accordionItemContainer: {
    padding: "0.5rem",
    textAlign: "left",
    transition: "color 0.5s, opacity 0.8s, transform 0.75s, max-height 0.5s",
  },
  container: {
    width: "100%",
    display: "flex",
    cursor: "pointer",
  },
  number: {
    fontSize: "3rem",
    paddingRight: "0.25rem",
    marginTop: "0.5rem",
  },
  title: {
    textAlign: "left",
    fontSize: "1rem",
  },
  contentContainer: {
    paddingBottom: "1rem",
    transition: "opacity 0.8s, transform 0.75s, max-height 0.5s",
    fontSize: "0.8rem",
    overflow: "hidden",
  },
};

AccordionItem.propTypes = {
  isActive: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
  fillColor: PropTypes.string.isRequired,
};

export default AccordionItem;
